<template>
  <span />
</template>

<script setup>
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ROUTE_COMMON, ROUTES_EMPLOYEES } from '@/app/data/route_constants';
import { mapActions } from '@/store/lib/vue3helpers.js';

const route = useRoute();
const router = useRouter();

const { FETCH_DECISIONS } = mapActions(['FETCH_DECISIONS']);

onMounted(async () => {
  try {
    const project_id = route.params.project_id;
    const decision_type_id = route.params.decision_type_id;
    const decisions = await FETCH_DECISIONS({ decision_type_id, unit_id: route.params.unit_id });
    const decision_id = _.get(decisions[0], 'id');
    router.replace({
      name: ROUTES_EMPLOYEES.PROJECT_DECISION_PROPOSALS,
      params: {
        project_id,
        decision_type_id,
        decision_id,
      },
    });
  } catch (e) {
    // redirect to root on failure and afterwards hard refresh to re-trigger init profile
    await router.replace({ name: ROUTE_COMMON.ROOT });
    window.location.reload();
  }
});
</script>
